import classNames from 'classnames';

const ftsStatusNameColor = {
  'Отсутствует привязка в M-Pro': 'bg-[#FF4728]',
  'Ожидает привязки к M-Pro': 'bg-[#D26629]',
  'Проверка годового лимита': 'bg-[#D26629]',
  'Превышен годовой лимит': 'bg-[#FF4728]',
  'Статус самозанятости отсутствует': 'bg-[#FF4728]',
  'Проверка ФИО и телефона': 'bg-[#D26629]',
  'Несовпадение ФИО и телефона': 'bg-[#FF4728]',
  'Несовпадение ФИО': 'bg-[#FF4728]',
  'Несовпадение телефона': 'bg-[#FF4728]',
  'Проверки ФНС пройдены': 'bg-[#217A0D]',
  'В процессе привязки': 'bg-[#D26629]',
  'Техническая ошибка': 'bg-[#FF4728]',
};

export const myExecutorsTableHeadings: TableHeading[] = [
  {
    attributeName: 'fullName',
    name: 'ФИО Исполнителя',
    renderColumn: (column) => <span className="whitespace-nowrap">{column as string}</span>,
  },
  {
    attributeName: 'tin',
    name: 'ИНН',
    renderColumn: (column) => (
      <span className="whitespace-nowrap">
        <span className="whitespace-nowrap">{column as string}</span>
      </span>
    ),
  },
  {
    attributeName: 'ftsStatusName',
    name: 'Статус проверки ФНС',
    renderColumn: (column) => (
      <span
        className={classNames(
          'block w-max rounded-[4px] px-2 py-[1px] text-sm text-white',
          ftsStatusNameColor[column as keyof typeof ftsStatusNameColor]
        )}
      >
        {column as string}
      </span>
    ),
  },
];
